export const PARKING_HOVER_EVENT = "parking-spot-hover" as const;
export type ParkingHoverEventDetail = {
  markerId: string | null;
};
